import DatePicker from './DatePicker';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(DatePicker);
